import { jsx as l, jsxs as s } from "react/jsx-runtime";
import { forwardRef as d } from "react";
const i = d(
  ({ id: e, label: t, name: c, error: a, warning: r, success: o, ...h }, n) => /* @__PURE__ */ l("li", { children: /* @__PURE__ */ s(
    "label",
    {
      className: "checkbox-ui",
      htmlFor: e,
      "data-error": a || null,
      "data-alert": r || null,
      "data-success": o || null,
      children: [
        /* @__PURE__ */ l("input", { type: "checkbox", ref: n, id: e, name: c, ...h }),
        /* @__PURE__ */ l("span", { children: t })
      ]
    }
  ) })
);
i.displayName = "Checkbox";
export {
  i as Checkbox
};
